import { render } from "./year.vue?vue&type=template&id=ea0cdb7e&scoped=true&ts=true"
import script from "./year.vue?vue&type=script&lang=ts&config=true"
export * from "./year.vue?vue&type=script&lang=ts&config=true"

import "./year.vue?vue&type=style&index=0&id=ea0cdb7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0cdb7e"]])

export default __exports__